var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',[_vm._v("\n    LOADING\n  ")]):_c('div',{attrs:{"id":"avgTimePerVote"}},[_c('div',{attrs:{"id":"avgTimePerVoteChart"}},[_c('apexchart',{attrs:{"type":"scatter","height":"350","options":_vm.avgTimePerVoteOptions,"series":_vm.avgTimePerVoteSeries}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a8cb106","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Visualizations/AvgTimePerVote.vue
// module id = null
// module chunks = 